var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('v-progress-circular',{attrs:{"size":50,"width":5,"color":"red accent-4","indeterminate":""}}),_c('p',{staticClass:"red--text text--darken-4"},[_vm._v("Be patient. Everything is coming together.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }